import { apiRequest, queryString } from "./http";
import type {
  ProjectMetadata,
  ApiListParams,
  ProjectMutation,
  ProjectParticipant,
  ProjectParticipantRole,
  ProjectRecord,
} from "./generated/openapi";

export type {
  ProjectMetadata,
  ProjectOption,
  ProjectParticipant,
  ProjectParticipantRole,
} from "./generated/openapi";

export const projectApi = {
  metadata: () => apiRequest<ProjectMetadata>("/api/projects/metadata"),

  list: (params: ApiListParams = {}) =>
    apiRequest<ProjectRecord[]>(`/api/projects${queryString(params)}`),

  create: (payload: ProjectMutation) =>
    apiRequest<ProjectRecord>("/api/projects", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  get: (id: string | number) => apiRequest<ProjectRecord>(`/api/projects/${id}`),

  update: (id: string | number, payload: ProjectMutation) =>
    apiRequest<ProjectRecord>(`/api/projects/${id}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),

  delete: (id: string | number) =>
    apiRequest<ProjectRecord>(`/api/projects/${id}`, { method: "DELETE" }),

  listParticipants: (id: string | number, signal?: AbortSignal) =>
    apiRequest<ProjectParticipant[]>(`/api/projects/${id}/participants`, {
      signal,
    }),

  assignParticipant: (
    id: string | number,
    userId: string,
    participantRole: ProjectParticipantRole,
  ) =>
    apiRequest<ProjectParticipant>(`/api/projects/${id}/participants`, {
      method: "POST",
      body: JSON.stringify({
        user_id: userId,
        participant_role: participantRole,
      }),
    }),

  endParticipant: (id: string | number, participantId: string) =>
    apiRequest<ProjectParticipant>(
      `/api/projects/${id}/participants/${participantId}`,
      { method: "DELETE" },
    ),
};
